import React, { useEffect, useState } from "react"

import DefaultLayout from "../../layouts/defaultLayout"
import LoadingDashboard from "../../components/loadingDashboard"
import EventDetailBody from "../../components/eventDetailBody"

import axios from "axios"

import { Link } from "react-router-dom"
import { useNavigate, useParams } from "react-router"
import { eventTimeFormatted } from "./events"
import { setErrors } from "../../redux/userSlice"
import { useDispatch } from "react-redux"

const EventNotify = () => {
  const { eventID } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [event, setEvent] = useState({})
  const [loading, setLoading] = useState(true)

  // List of trainees with numbers
  const [notifList, setNotifList] = useState([])
  const [notVerified, setNotVerified] = useState([])
  // List of trainees selected to notify

  // Notification content
  const [notifContent, setNotifContent] = useState("")

  const [notifLoading, setNotifLoading] = useState(false)
  const [notifError, setNotifError] = useState("")

  useEffect(() => {
    if (eventID && eventID.length > 0) {
      axios
        .get(`/get-event/?event_id=${eventID}`)
        .then((res) => {
          setEvent(res.data)
          setLoading(false)
          setNotifList([])
          setNotVerified([])
          res.data.trainees.map((t) => {
            if (t.phone_number && t.phone_number.length > 0 && t.is_verified) {
              setNotifList((prev) => [...prev, t])
            } else {
              setNotVerified((prev) => [...prev, t])
            }
          })

          const eventTime = eventTimeFormatted(res.data)
          // Set default template notification message
          setNotifContent(`EVENT REMINDER: You are signed up for the following event: ${res.data.title} 
DATE-TIME: ${eventTime},

DESCRIPTION: ${res.data.description}`)
        })
        .catch((err) => {
          console.log(err)
          dispatch(
            setErrors(["An error has occured, please reefresh and try again"])
          )
          if (err.response.status === 404) {
            dispatch(setErrors(["An event with this id does not exist"]))
          } else if (err.response.status === 403) {
            dispatch(setErrors(["You are not authorized to view this event"]))
          } else {
            dispatch(
              setErrors([
                "An unexpected error has occured, please return to the previous page and try again",
              ])
            )
          }
          setLoading(false)
        })
    }
  }, [eventID])

  const handleSend = () => {
    setNotifLoading(true)

    if (notifContent.length <= 0) {
      setNotifLoading(false)
      setNotifError("Please enter more a message")
      return
    }

    if (notifContent.length > 450) {
      setNotifLoading(false)
      setNotifError("Please enter less than 450 characters")
      return
    }

    const body = {
      notify_type: "custom",
      message: notifContent,
      trainees: notifList.map((t) => t.id),
    }
    axios
      .post("/notify-trainees", body)
      .then(() => {
        navigate("/events")
      })
      .catch((err) => {
        setNotifLoading(false)
        console.log(err)
        setNotifError(
          "An error occured while sending the notification, please try again"
        )
      })
  }

  if (loading) {
    return <LoadingDashboard />
  }

  return (
    <DefaultLayout disableTeams>
      <h1>
        {event.title}{" "}
        <Link
          className="default-button"
          to={`/event/${event.id}/edit`}
          style={{ fontSize: "1rem" }}
        >
          Edit Event
        </Link>
      </h1>
      <div className="row" style={{ padding: "1rem 0" }}>
        <div className="col-sm-6">
          <EventDetailBody event={event} />
          <Link to="/events" style={{ textDecoration: "none" }}>
            <span className="default-button">Go back</span>
          </Link>
        </div>
        <div className="col-sm-6">
          <div className="card">
            <div className="card-body">
              <h5>Remind attendees</h5>
              {!event.trainees ||
                (event.trainees.length === 0 ? (
                  <p>There are no trainees signed up for this event</p>
                ) : notifList.length >= 0 ? (
                  <div>
                    <p>Message Content</p>
                    <textarea
                      rows={10}
                      style={{ width: "100%", padding: "0.5rem" }}
                      value={notifContent}
                      onChange={(e) => setNotifContent(e.target.value)}
                      maxLength={450}
                    />
                    <p
                      style={{
                        float: "right",
                        marginTop: "-5px",
                        fontSize: "0.70rem",
                        color: notifContent.length >= 450 ? "red" : "gray",
                        marginBottom: 0,
                      }}
                    >
                      {notifContent.length}/450
                    </p>
                    <p>
                      The above message is only a template. We recommend you
                      edit and add additional details, including your signature.
                    </p>
                    <p>
                      NOTE: The following attendees (with valid & verified phone
                      numbers) will be notified:
                    </p>
                    <ul>
                      {notifList.map((t) => {
                        return (
                          <div>
                            <li key={t.id}>
                              <h3 className="d-inline">&#x2705;</h3>
                              {t.name} ({t.phone_number})
                            </li>
                          </div>
                        )
                      })}
                    </ul>

                    {notVerified.length > 0 ? (
                      <div>
                        <p>
                          NOTE: The following attendees do not have valid &
                          verified phone numbers and will not be notified:
                        </p>
                        <ul>
                          {notVerified.map((t) => {
                            return (
                              <div>
                                <li key={t.id}>
                                  <h3 className="d-inline">&#x274C;</h3>
                                  {t.name} ({t.phone_number})
                                </li>
                              </div>
                            )
                          })}
                        </ul>{" "}
                      </div>
                    ) : (
                      ""
                    )}

                    {notifError && notifError.length > 0 && (
                      <div className="h6 text-center text-danger">
                        {notifError}
                      </div>
                    )}
                    <div>
                      <button
                        diasbled={notifLoading}
                        className="default-button"
                        onClick={handleSend}
                      >
                        Send
                      </button>
                      <Link
                        diasbled={notifLoading}
                        to="/events"
                        className="default-button default-button-gray"
                      >
                        Cancel
                      </Link>
                    </div>
                  </div>
                ) : (
                  <p>
                    No attendees have phone numbers. Please add/edit phone
                    numbers{" "}
                    <Link
                      to="/communications"
                      style={{ textDecoration: "none" }}
                    >
                      <b>here</b>
                    </Link>
                    .
                  </p>
                ))}
            </div>
          </div>
        </div>
      </div>
    </DefaultLayout>
  )
}

export default EventNotify
